<template>
<v-card elevation="4" tile>
    <div class="primary dark">
        <v-card-title class="white--text">INSTITUCIONES</v-card-title>
        <v-divider/>
        <v-tabs dark background-color="primary">
            <v-tab>ADMINISTRACIÓN</v-tab>
            <v-tab-item>
                <Cpanel/>
            </v-tab-item>
        </v-tabs>
    </div>
</v-card>
</template>
<script>
import Cpanel from '@/components/entities/institution/cpanel.vue';

export default {
    components: {
        Cpanel,
    }
}

</script>